import { imageUrl } from "@/lib/api";

// Read-only view for someone opening an owner's share link (no editing, no account needed).
export const SharedBook = ({ book }) => (
  <article data-testid="shared-book" className="max-w-2xl mx-auto py-10">
    {book.cover_image_id && (
      <img src={imageUrl(book.cover_image_id)} alt={`${book.title} cover`} data-testid="shared-book-cover"
        className="w-56 mx-auto rounded-lg shadow-2xl mb-8" />
    )}
    <h1 data-testid="shared-book-title" className="font-display text-4xl sm:text-5xl text-center text-slate-100">{book.title}</h1>
    {book.subtitle && <p className="font-read text-center text-slate-300 mt-3">{book.subtitle}</p>}
    {book.author && <p className="font-ui text-center text-sm text-gold-200/90 mt-2">by {book.author}</p>}
    {(book.chapters || []).map((c) => (
      <section key={c.number} data-testid={`shared-chapter-${c.number}`} className="mt-14">
        <h2 className="font-display text-2xl text-slate-100 mb-5">{c.no_number ? c.title : `Chapter ${c.number}: ${c.title}`}</h2>
        {c.image_id && <img src={imageUrl(c.image_id)} alt="" className="w-full rounded-lg mb-6" />}
        {(c.content || "").split(/\n{2,}/).map((p, i) => (
          <p key={i} className="font-read text-base text-slate-200 leading-relaxed mb-4">{p.replace(/[*_#]+/g, "")}</p>
        ))}
      </section>
    ))}
  </article>
);
